/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isEqual } from 'lodash';

const DEFAULT_SORT = { name: 1 };

class TableListContainer extends Component {
  state = {
    currentPage: 1,
    searching: false,
    searchValue: '',
    sort: DEFAULT_SORT
  };

  componentDidUpdate(prevProps) {
    const { Page } = this.props;
    const { Page: prevPage } = prevProps;
    if (!isEqual(Page, prevPage)) {
      this.resetState();
    }
  }

  resetState = () => {
    this.setState({ searching: true, searchValue: '', currentPage: 1, sort: DEFAULT_SORT });
  };

  handleSearch = event => {
    event.persist();
    if (!isEmpty(event.target.value.trim())) {
      this.setState({ searching: true, searchValue: event.target.value.trim(), currentPage: 1 });
    } else {
      this.setState({ searching: false, searchValue: '', currentPage: 1 });
    }
  };

  changePage = pageNumber => {
    this.setState({ currentPage: pageNumber });
  };

  handleSort = property => {
    const { sort } = this.state;
    const newSort = {};
    newSort[property] = sort[property] === 1 ? -1 : 1;
    this.setState({ sort: newSort });
  };

  render() {
    const { Page, ...rest } = this.props;

    return (
      <Page
        changePage={this.changePage}
        handleSearch={this.handleSearch}
        handleSort={this.handleSort}
        {...this.state}
        {...rest}
      />
    );
  }
}

TableListContainer.propTypes = {
  Page: PropTypes.func.isRequired
};

export default TableListContainer;
